import { withTranslation } from "react-i18next";
import InvoiceInfo from './InvoiceInfo';

export default withTranslation()(InvoiceInfo);